import type { TicketClassification, TicketProduct } from '@yhelp/shared-types';

export const TICKET_PRODUCTS: { value: TicketProduct; label: string }[] = [
  { value: 'cloudflare', label: 'Cloudflare' },
  { value: 'okta', label: 'Okta' },
  { value: 'auth0', label: 'Auth0' },
  { value: 'yface', label: 'yFace' },
];

export const TICKET_CLASSIFICATIONS: { value: TicketClassification; label: string }[] = [
  { value: 'troubleshoot', label: 'Troubleshoot' },
  { value: 'melhoria', label: 'Melhoria' },
  { value: 'feedback', label: 'Feedback' },
  { value: 'implementacao', label: 'Implementação' },
  { value: 'outro', label: 'Outro' },
];

export const CLASSIFICATION_STYLES: Record<
  TicketClassification,
  { bg: string; text: string; ring: string }
> = {
  troubleshoot: {
    bg: 'bg-red-100 dark:bg-red-950',
    text: 'text-red-800 dark:text-red-200',
    ring: 'ring-red-300 dark:ring-red-800',
  },
  melhoria: {
    bg: 'bg-blue-100 dark:bg-blue-950',
    text: 'text-blue-800 dark:text-blue-200',
    ring: 'ring-blue-300 dark:ring-blue-800',
  },
  feedback: {
    bg: 'bg-purple-100 dark:bg-purple-950',
    text: 'text-purple-800 dark:text-purple-200',
    ring: 'ring-purple-300 dark:ring-purple-800',
  },
  implementacao: {
    bg: 'bg-green-100 dark:bg-green-950',
    text: 'text-green-800 dark:text-green-200',
    ring: 'ring-green-300 dark:ring-green-800',
  },
  outro: {
    bg: 'bg-neutral-200 dark:bg-neutral-800',
    text: 'text-neutral-800 dark:text-neutral-200',
    ring: 'ring-neutral-300 dark:ring-neutral-700',
  },
};

export function productLabel(product?: TicketProduct | null): string {
  if (!product) return '—';
  return TICKET_PRODUCTS.find((p) => p.value === product)?.label ?? product;
}

export function classificationLabel(classification?: TicketClassification | null): string {
  if (!classification) return '—';
  return TICKET_CLASSIFICATIONS.find((c) => c.value === classification)?.label ?? classification;
}
